import CBT from "../assets/images/screen.svg";
import Pastoral from "../assets/images/pastoral.svg";
import HR from "../assets/images/people2.svg";
import Finance from "../assets/images/half-circle.svg";
import Calendar from "../assets/images/calendar.svg";
import Eclassroom from "../assets/images/read-book.svg";
import Wallet from "../assets/images/wallet.svg";
import Report from "../assets/images/chart.svg";
import Admission from "../assets/images/students.svg";
import Mailbox from "../assets/images/message.svg";
import Medicals from "../assets/images/med.svg";
import Timetable from "../assets/images/timetable.svg";
import Lesson from "../assets/images/note.svg";
import Library from "../assets/images/lib.svg";
import Facility from "../assets/images/people.svg";
import Remarks from "../assets/images/remark.svg";
import Voting from "../assets/images/voting.svg";
import Daily from "../assets/images/daily.svg";
import Clubs from "../assets/images/club2.svg";
import Assignments from "../assets/images/assignment2.svg";

export const allProducts = [
  {
    productTitle: "Finance",
    productDetail:
      "The one and only accounting and payroll solution your business will ever need.",
    productIcon: Finance,
    border: "solid 1px #4A13B2",
    bg: "#DED0FA80",
    category: ["business", "schools"],
  },
  {
    productTitle: "Pastoral",
    productDetail:
      "Enhance your institution’s pastoral care with our innovative software platform.",
    productIcon: Pastoral,
    border: "solid 1px #ED2F59",
    bg: "#FCDCE3",
    category: ["schools"],
  },
  {
    productTitle: "Students Admission",
    productDetail:
      "Transform your admissions process with our streamlined software platform.",
    productIcon: Admission,
    border: "solid 1px #0098DA",
    bg: "#CEF0FF80",
    category: ["schools"],
  },
  {
    productTitle: "Lesson Planner",
    productDetail:
      "Streamline and simplify your lesson planning process with our lesson planner.",
    productIcon: Lesson,
    border: "solid 1px #11A377",
    bg: "#CDFAEC80",
    category: ["schools"],
  },
  {
    productTitle: "HR Manager",
    productDetail:
      "Streamline your HR tasks with our comprehensive HR manager.",
    productIcon: HR,
    border: "solid 1px #EA8713",
    bg: "#FCEBD780",
    category: ["business", "schools"],
  },
  {
    productTitle: "CBT",
    productDetail:
      "Revolutionize your testing process with our computer-based test platform.",
    productIcon: CBT,
    border: "solid 1px #11A377",
    bg: "#CDFAEC80",
    category: ["schools"],
  },
  {
    productTitle: "MailBox",
    productDetail: "Simplify communication with our powerful mailbox.",
    productIcon: Mailbox,
    border: "solid 1px #C32BD6",
    bg: "#F5DCF880",
    category: ["business", "schools"],
  },
  {
    productTitle: "Library",
    productDetail:
      "Simplify your library management with our innovative software platform.",
    productIcon: Library,
    border: "solid 1px #ED2F59",
    bg: "#FCDCE380",
    category: ["schools"],
  },
  {
    productTitle: "Report",
    productDetail:
      "Generate detailed school reports with ease using our user-friendly report.",
    productIcon: Report,
    border: "solid 1px #0098DA",
    bg: "#CEF0FF80",
    category: ["business", "schools"],
  },
  {
    productTitle: "eClassroom",
    productDetail:
      "Revolutionize your testing process with our computer-based test platform.",
    productIcon: Eclassroom,
    border: "solid 1px #FF0089",
    bg: "#FFD5EB80",
    category: ["schools"],
  },
  {
    productTitle: "Medicals",
    productDetail:
      "Streamline medical operations with our innovative software platform.",
    productIcon: Medicals,
    border: "solid 1px #0B2FF7",
    bg: "#D6DCFE80",
    category: ["business", "schools"],
  },
  {
    productTitle: "Facility Management",
    productDetail:
      "Optimize your workforce with our staff management platform.",
    productIcon: Facility,
    border: "solid 1px #0B2FF7",
    bg: "#D6DCFE80",
    category: ["business", "schools"],
  },
  {
    productTitle: "Calendar",
    productDetail:
      "Stay organized and on schedule with our intuitive calendar platform.",
    productIcon: Calendar,
    border: "solid 1px #0098DA",
    bg: "#CEF0FF80",
    category: ["business", "schools"],
  },
  {
    productTitle: "Wallet Manager",
    productDetail:
      "Take control of your finances with our intuitive wallet manager platform.",
    productIcon: Wallet,
    border: "solid 1px #11A377",
    bg: "#CDFAEC80",
    category: ["business", "schools"],
  },
  {
    productTitle: "Timetable",
    productDetail:
      "Organize schedules with ease using our intuitive timetable platform.",
    productIcon: Timetable,
    border: "solid 1px #C32BD6",
    bg: "#F5DCF880",
    category: ["schools"],
  },
  {
    productTitle: "Weekly remarks",
    productDetail:
      "Effortlessly track performance with our weekly remarks platform.",
    productIcon: Remarks,
    border: "solid 1px #C32BD6",
    bg: "#F5DCF880",
    category: ["business", "schools"],
  },
  {
    productTitle: "Voting System",
    productDetail:
      "Securely manage and conduct elections with our powerful voting system platform.",
    productIcon: Voting,
    border: "solid 1px #0098DA",
    bg: "#CEF0FF80",
    category: ["schools"],
  },
  {
    productTitle: "Assignments",
    productDetail: "Create assignments for Students in your school.",
    productIcon: Assignments,
    border: "solid 1px #11A377",
    bg: "#CDFAEC80",
    category: ["schools"],
  },
  {
    productTitle: "Clubs",
    productDetail:
      "Track and monitor your School activities outside core curriculum.",
    productIcon: Clubs,
    border: "solid 1px #C32BD6",
    bg: "#F5DCF880",
    category: ["schools"],
  },
  {
    productTitle: "Daily Reporting",
    productDetail:
      "Submit daily reports, to keep track of updates in your organisation.",
    productIcon: Daily,
    border: "solid 1px #EA8713",
    bg: "#FCEBD740",
    category: ["business", "schools"],
  },
];
